import { useEffect } from 'react';
import { musicGenreCatalogQuery } from './MusicGenreCatalogLifecycle';
import { setRemoteMusicGenreCatalog, useMusicGenreCatalogRevision } from './generated/localization';
import { useQuery } from '@tanstack/react-query';
import api from '../../api/api';
import { useUserStore } from '../../stores/userStore';
import { featurePayload, tastePayload } from './tasteModel';
export default function useMyTaste(profile, summary, publicProfile = false) {
  const user = useUserStore((s) => s.user);
  const owned =
    user?.id != null &&
    String(user.id) === String(profile.id) &&
    user.nickname === profile.nickname;
  const enabled = publicProfile ? profile?.id != null && !!profile.nickname : owned;
  const publicKey = ['publicTaste', user?.id ?? 'guest', profile?.id, profile?.nickname];
  const get = publicProfile && !user?.id ? api.getPublic : api.getAuth;
  useMusicGenreCatalogRevision();
  const catalog = useQuery({
    ...musicGenreCatalogQuery,
    enabled,
  });
  useEffect(() => {
    if (catalog.data) setRemoteMusicGenreCatalog(catalog.data);
  }, [catalog.data]);
  const taste = useQuery({
    queryKey: publicProfile ? [...publicKey, 'analysis'] : ['myTaste', user?.id, 'analysis'],
    queryFn: async ({ signal }) =>
      tastePayload(
        await get(
          publicProfile
            ? `/users/${encodeURIComponent(profile.nickname)}/taste-analysis`
            : '/me/taste-analysis',
          { signal, suppressGlobalError: true },
        ),
      ),
    enabled,
    retry: false,
    gcTime: 0,
  });
  const features = useQuery({
    queryKey: publicProfile
      ? [...publicKey, 'features']
      : ['myTaste', user?.id, profile.nickname, 'features'],
    queryFn: async ({ signal }) =>
      featurePayload(
        await get(`/users/${encodeURIComponent(profile.nickname)}/music-features`, {
          signal,
          suppressGlobalError: true,
        }),
      ),
    enabled: enabled && summary,
    retry: false,
    gcTime: 0,
  });
  return { enabled, taste, features };
}
